<div class="teams-overview-page-header">
    <div class="teams-overview-page-title-container">
        <h2 class="teams-overview-page-title">{{'teams_overview' | translate}}</h2>
        <span class="export-data"
            pTooltip="{{'wo_tooltip_coming_soon'|translate}}" tooltipPosition="bottom" tooltipStyleClass="generate-report-tooltip">{{'team_export' | translate}}</span>
    </div>
    <div class="sorting-btns-container">
        <div class="days-sorting-container">
            <button pButton (click)="sortByDays(30);$event.stopPropagation()"
                [ngClass]="is30DaysSorting ? 'active':''"
                class="sorting-days-btn" 
                label="{{'to_sort_30_days' | translate}}"></button>
            <button pButton (click)="sortByDays(90);$event.stopPropagation()" 
                [ngClass]="is90DaysSorting ? 'active':''" 
                class="sorting-days-btn" 
                label="{{'to_sort_90_days' | translate}}"></button>
        </div>
        <div class="categories-sorting-container">
            <p-button *ngFor="let btn of sortingByIndicators, let index = index" (onClick)="sortByCategory(index)" [styleClass]="btn.active ? 'category-btn active':'category-btn'">
                <ng-template pTemplate="content">
                    <img *ngIf="btn.icon !== ''" style="width: 2rem;height: 2rem;" alt="category" src="../../../assets/icons/{{btn.active ? btn?.icon:'inactive_'+btn?.icon}}.svg">
                    <span>{{btn.name}}</span>
                </ng-template>
            </p-button>
        </div>
    </div>
</div>